export default {
  METRIC_KEY_NEW_PAYMENT: 'acesspage',
  METRIC_KEY_BOOKING_CONVERSION: 'bookingConversionRevenue',
  METRIC_KEY_ACCESS_PAGE: 'acesspage',
  METRIC_KEY_VIEW_CONFIGURE_PAGE: 'viewConfigurePage',
  METRIC_KEY_VIEW_PAYMENT_PAGE: 'viewPaymentPage',
  METRIC_KEY_RENTAL_COVER_CONVERSION: 'rentalcoverConversionRevenue2',
  METRIC_KEY_VIEW_NO_RESULTS: 'viewNoResults',
  METRIC_KEY_OPTIONALS_CONVERSION: 'optionalsIncludedConversion',
  METRIC_KEY_BOOKING_CONVERSION_PP: 'bookingConversionPp',
  METRIC_KEY_BOOKING_CONVERSION_ALL: 'bookingConversionAll',
  METRIC_KEY_VIEW_LOGIN_PAGE: 'viewLoginPage',
  METRIC_KEY_LOGIN_TO_PAYMENT: 'loginToPayment',
  METRIC_KEY_RENTPROTECTION_GENERAL_CONVERSION: 'nrBookingConversionPwa',
  METRIC_KEY_RENTPROTECTION_SERVICE_CONVERSION: 'nrProtectionIncludedConversionPwa',
  METRIC_KEY_RENTPROTECTION_GENERAL_PAYMENT: 'nrPaymentProtectionGeneralPwa',
  METRIC_KEY_RENTPROTECTION_SERVICE_PAYMENT: 'nrPaymentProtectionIncludedPwa',
  METRIC_KEY_RENTPROTECTION_GENERAL_PAYMENT_LOCAL: 'nrPaymentProtectionGeneralLocal',
  METRIC_KEY_RENTPROTECTION_SERVICE_PAYMENT_LOCAL: 'nrPaymentProtectionIncludedLocal',
  METRIC_KEY_RENTPROTECTION_GENERAL_CONVERSION_LOCAL: 'nrBookingConversionLocal',
  METRIC_KEY_RENTPROTECTION_SERVICE_CONVERSION_LOCAL: 'nrProtectionIncludedConversionLocal',
  METRIC_KEY_BOOKING_CONVERSION_DOMESTIC: 'xpPwaBookingConversion',
  METRIC_KEY_BOOKING_CONVERSION_OUTBOUND: 'xpPwaBookingConversionOutbound',
  METRIC_KEY_RENTAL_COVER_DOMESTIC: 'xpPwaRentalCoverConversionInb',
  METRIC_KEY_RENTAL_COVER_OUTBOUND: 'xpPwaRentalCoverConversionOut',
  METRIC_KEY_RENTAL_GENERAL_PAYMENT_DOMESTIC: 'xpPwaGeneralPaymentInbound',
  METRIC_KEY_RENTAL_GENERAL_PAYMENT_OUTBOUND: 'xpPwaGeneralPaymentOutbound',
  METRIC_KEY_RENTAL_PAYMENT_WITH_PROTECTION_DOMESTIC: 'xpPwaPaymentWithProtection',
  METRIC_KEY_RENTAL_PAYMENT_WITH_PROTECTION_OUTBOUND: 'xpPwaPaymentWithProtectionOut',
  METRIC_KEY_RENTAL_COVER_PAYMENT_VIEW_WITH_RC: 'xpPwaViewPaymentWithRc',
  METRIC_KEY_RENTAL_COVER_PAYMENT_VIEW_WITHOUT_RC: 'xpPwaViewPaymentWithoutRc',
  METRIC_KEY_RENTAL_COVER_BOOKING_CONVERSION_ROW_WITH_RC: 'xpPwaBookingConversionRcRow',
  METRIC_KEY_RENTAL_COVER_BOOKING_CONVERSION_ROW_WITHOUT_RC: 'xpPwaBookingConversionRow',
  METRIC_KEY_RENTALCOVER_ABC_DOMESTIC_PAYMENT_VIEW_WITH_RC: 'xpPwaViewPaymentDomesticWithRc',
  METRIC_KEY_RENTALCOVER_ABC_DOMESTIC_PAYMENT_VIEW_WITHOUT_RC: 'xpPwaViewPaymentDomWithoutRc',
  METRIC_KEY_RENTALCOVER_ABC_DOMESTIC_BOOKING_CONVERSION_WITH_RC: 'xpPwaBookingConversionRcDomestic',
  METRIC_KEY_RENTALCOVER_ABC_DOMESTIC_BOOKING_CONVERSTION_WITHOUT_RC: 'xpPwaBookingConversionDomestic',
  // Novas métricas experimento filtros (placeholders - ajustar com keys reais quando criadas no VWO)
  METRIC_KEY_FILTERS_INTERACTED_CONVERTED: 'sxpNewFiltersBookingConversionPwa',
  METRIC_KEY_FILTERS_NOT_INTERACTED_CONVERTED: 'sxpNewFiltersBookingConversionPwaOf',
  METRIC_KEY_FILTERS_VIEW_CONFIGURE: 'sxpNewFiltersViewConfigurePwa',
  METRIC_KEY_FILTERS_VIEW_CONFIGURE_OFF: 'sxpNewFiltersViewConfigPwaOff',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_DOMESTIC: 'xpPwaBookingConversionDomestic',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_DOMESTIC: 'xpPwaBookingConversionRcDomestic',
  METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_DOMESTIC: 'xpPwaViewPaymentDomestic',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_OUTBOUND: 'xpPwaBookingConversionOutbound',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_OUTBOUND: 'xpPwaBookingConversionRcOut',
  METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_OUTBOUND: 'xpPwaGeneralPaymentOutbound',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_LATAM: 'xpPwaBookingConversionLatam',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_LATAM: 'xpPwaBookingConversionRcLatam',
  METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_LATAM: 'xpPwaViewPaymentLatam',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_ROW: 'xpPwaBookingConversionRow',
  METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_ROW: 'xpPwaBookingConversionRcRow',
  METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_ROW: 'xpPwaViewPaymentRow',
  METRIC_KEY_MULTISTORE_VIEW_CONFIGURE: 'sxpMultistoreConfigurePwa',
  METRIC_KEY_MULTISTORE_VIEW_CONFIGURE_FALLBACK: 'sxpMultistoreConfigureFallbackPwa',
  METRIC_KEY_MULTISTORE_CONVERTED: 'sxpMultistoreConversionPwa',
  // Metricas para Info Profile Analysis
  METRIC_KEY_VIEW_PAYMENT_PROFILE_ANALYSIS: 'xpPwaViewPaymentProfileAnalysis',
  METRIC_KEY_BOOKING_CONVERSION_PROFILE_ANALYSIS: 'xpPwaBookingConversionPa',
  // Metricas para alerta de PID
  METRIC_KEY_ADVANCE_PAYMENT: 'xpPwaAdvancePayment',
  METRIC_KEY_CONVERSION_BOOKING: 'xpPwaBookingConversionPid'
}
